import React from "react";
import Image from "next/image";
import classNames from "classnames";

// components
import SearchMapMarkCarousel from "./SearchMapMarkCarousel";

// interfaces
import { ISearchMapMarkContent } from "../ISearchMapMark";

// assets
import styles from "@/assets/styles/components/search-map-mark.module.scss";

const SearchMapMarkContent = ({
  accessRestricted,
  location,
}: ISearchMapMarkContent) => {
  const { image, pictureUrl, images, description, slug, city, locationName, name } = location;

  const link = `/location/${slug}`;
  const locationNameClassNames = classNames(
    styles["locl-search-map-mark-popover__location"],
    { [styles["locl-search-map-mark-popover__location-restricted"]]: accessRestricted }
  );

  const renderCity = () => {
    if (typeof city === "string") {
      return city;
    }

    return city?.name;
  };

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className={styles["locl-search-map-mark-popover__link"]}
    >
      {!images?.length ? (
        <Image
          width={208}
          height={126}
          loading="lazy"
          src={image || pictureUrl}
          className={styles["locl-search-map-mark-popover__image"]}
          data-testid="locl-search-map-mark-single-img"
          alt={description}
        />
      ) : (
        <div
          className={styles["locl-search-map-mark-popover__slider_wrapper"]}
          data-testid="locl-search-map-mark-slider-wrapper"
          onClick={(e) => e.preventDefault()}
        >
          <SearchMapMarkCarousel
            className={styles["locl-search-map-mark-popover__slider"]}
            items={images?.map((img) => ({ src: img })) || []}
            imageStyle={{ filter: `${accessRestricted ? "blur(5px)" : "none"}`, }}
          />
        </div>
      )}
      <div className={styles["locl-search-map-mark-popover__info"]}>
        <div className={styles["locl-search-map-mark-popover__city"]}>{renderCity()}</div>
        <div className={locationNameClassNames}>
          {locationName || name}
        </div>
      </div>
    </a>
  );
};

export default SearchMapMarkContent;
